import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { useAccount } from "api/services/useAccount";


export interface BlocksType {
  iqIsBlocked: boolean;
  escalationIsBlocked: boolean;
  detectorIsBlocked: boolean;
}
interface UserLimitState {
  data: BlocksType;
  loading: boolean;
  error: string | null;
}

const initialState: UserLimitState = {
  data: {
    iqIsBlocked: false,
    escalationIsBlocked: false,
    detectorIsBlocked: false,
  },
  loading: false,
  error: null,
};

export const getUserLimit = createAsyncThunk("userLimit/getUserLimit", async () => {
  const { accountLimits, accountLimitsError } = await useAccount();
  if (!accountLimitsError && accountLimits) {
    return {
      iqIsBlocked: accountLimits.iq_is_blocked,
      escalationIsBlocked: accountLimits.escalation_is_blocked,
      detectorIsBlocked: accountLimits.detector_is_blocked,
    };
  }
  throw new Error("Failed to fetch user limits");
});

const userLimitSlice = createSlice({
  name: "userLimit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserLimit.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserLimit.fulfilled, (state, action: PayloadAction<BlocksType>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getUserLimit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch user limits";
      });
  },
});

export default userLimitSlice;
